.container {
  min-width: 320px;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.buttonGroup {
  display: flex;
  justify-content: flex-end;
}
